import React, { useMemo } from "react";
import _ from "lodash";
import { ICellRendererParams } from "ag-grid-community";
import { IRowData } from "components/shipment-review/types";
import { makeStyles, Theme } from "@material-ui/core/styles";

export const PriceWithStrikethroughCell: React.FunctionComponent<CastProp<ICellRendererParams, "data", IRowData>> = (
    props,
) => {
    const { formatValue, value } = props;
    const displayValue = useMemo(() => value?.[0] ?? value, [value]);
    const originalValue = useMemo(() => value?.[1] ?? null, [value]);

    const formattedDisplayValue = useMemo(
        () => (_.isNil(displayValue) ? "" : formatValue(displayValue)),
        [displayValue, formatValue],
    );
    const formattedOriginalValue = useMemo(() => {
        // originalValue has valid non-empty NUMBER or RANGE value
        if (
            !_.isNil(originalValue) &&
            displayValue !== originalValue &&
            (!_.isArray(originalValue) || !_.isEmpty(originalValue))
        ) {
            return formatValue(originalValue);
        }
        return null;
    }, [displayValue, formatValue, originalValue]);
    const displayOriginalValue = useMemo(
        () => !_.isNull(formattedOriginalValue) && formattedOriginalValue !== formattedDisplayValue,
        [formattedDisplayValue, formattedOriginalValue],
    );
    const classes = useStyles({ displayOriginalValue });

    return (
        <div className={classes.cell}>
            <span className={classes.price}>{formattedDisplayValue}</span>
            {displayOriginalValue && <span className={classes.priceOriginal}>{formattedOriginalValue}</span>}
        </div>
    );
};

const useStyles = makeStyles<Theme, { displayOriginalValue?: boolean }>({
    cell: ({ displayOriginalValue }) => ({
        lineHeight: "45px",
        ...(displayOriginalValue && {
            display: "flex",
            flexDirection: "column",
            lineHeight: "15px",
            height: "45px",
        }),
    }),
    price: ({ displayOriginalValue }) => ({
        paddingTop: "3px",
        verticalAlign: "middle",
        ...(displayOriginalValue && {
            color: "green",
            flexBasis: "50%",
        }),
    }),
    priceOriginal: {
        paddingTop: "3px",
        verticalAlign: "middle",
        textDecoration: "line-through",
        flexBasis: "50%",
    },
});
